import React from "react";

import PropTypes from "prop-types";
import styled from "styled-components";

const StyledCloseButton = styled.button`
  background-color: transparent;
  border: none;

  .bi-x {
    font-size: 2.5rem;
  }
`;

const StyledCloseIcon = styled.i`
  color: ${({ theme, textColor }) => textColor || theme.negativeTextColor};
`;

function ModalCloseButton(props) {
  const { onClick, textColor, backgroundColor } = props;

  return (
    <StyledCloseButton
      aria-label="Close"
      backgroundColor={backgroundColor}
      className="h-auto ms-auto px-0 py-0"
      onClick={onClick}
      type="button"
    >
      <StyledCloseIcon className="bi bi-x" textColor={textColor} />
    </StyledCloseButton>
  );
}

export default ModalCloseButton;

ModalCloseButton.defaultProps = {
  backgroundColor: null,
  textColor: null,
};

ModalCloseButton.propTypes = {
  backgroundColor: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  textColor: PropTypes.string,
};
